import { render, staticRenderFns } from "./CreateLifeType.vue?vue&type=template&id=39d54156&scoped=true"
import script from "./CreateLifeType.vue?vue&type=script&lang=js"
export * from "./CreateLifeType.vue?vue&type=script&lang=js"
import style0 from "./CreateLifeType.vue?vue&type=style&index=0&id=39d54156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d54156",
  null
  
)

export default component.exports